import { inject, Injectable } from '@angular/core';

import { RatingScalePresentation } from '@core/candidate-evaluation-settings-types';
import {
  RatingThumbOption,
  THUMBS_4_OPTIONS,
  THUMBS_4_SCORES,
  THUMBS_5_OPTIONS,
  THUMBS_5_SCORES,
} from '@core/evaluations-util';
import { I18nService } from '@core/i18n-legacy';
import type { RatingScalePresentationConfig } from '@recruitee/candidate-evaluation-settings-types';

@Injectable({ providedIn: 'root' })
export class RatingScalePresentationService {
  private readonly i18n = inject(I18nService);

  public getConfig(
    presentation: RatingScalePresentation,
    range: number,
  ): RatingScalePresentationConfig | null {
    switch (presentation) {
      case RatingScalePresentation.Thumbs4:
        return this.toIconItems(THUMBS_4_OPTIONS, THUMBS_4_SCORES);
      case RatingScalePresentation.Thumbs5:
        return this.toIconItems(THUMBS_5_OPTIONS, THUMBS_5_SCORES);
      case RatingScalePresentation.Numeric:
        return this.toNumericItems(range);
      default:
        return null;
    }
  }

  private toIconItems(
    options: RatingThumbOption[],
    scores: number[],
  ): RatingScalePresentationConfig {
    return options.map((option, index) => ({
      icon: option.icon,
      color: option.color,
      label: this.i18n.translate(option.translationKey),
      score: scores[index],
    }));
  }

  private toNumericItems(range: number): RatingScalePresentationConfig {
    return Array.from({ length: range }, (_, index) => ({
      icon: null,
      color: null,
      label: String(index + 1),
      score: index + 1,
    }));
  }
}
